

export let GET_ALLPAGE_REQUEST="GET_ALLPAGE_REQUEST"

export let GET_ALLPAGE_SUCCESS="GET_ALLPAGE_SUCCESS"
export let GET_ALLPAGE_FAILURE="GET_ALLPAGE_FAILURE"